export interface AmbienteChunk {
  recarrega: () => void;
  armazenamento: Pick<Storage, "getItem" | "setItem"> | null;
  agora: () => number;
  espera: (ms: number) => Promise<void>;
}

const CHAVE_RECARGA = "chunkRecarregadoEm";
const INTERVALO_MINIMO_ENTRE_RECARGAS_MS = 60000;
const ESPERA_ANTES_DE_TENTAR_DE_NOVO_MS = 1000;

const armazenamentoDoNavegador = () => {
  try {
    return window.sessionStorage;
  } catch (erro) {
    return null;
  }
};

const AMBIENTE_NAVEGADOR: AmbienteChunk = {
  recarrega: () => window.location.reload(),
  armazenamento: armazenamentoDoNavegador(),
  agora: () => Date.now(),
  espera: (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
};

export const erroDeChunk = (erro: any) =>
  Boolean(erro) &&
  (erro.name === "ChunkLoadError" || erro.code === "CSS_CHUNK_LOAD_FAILED" || /Loading (CSS )?chunk \S+ failed/i.test(String(erro.message)));

const registraRecarga = (ambiente: AmbienteChunk) => {
  try {
    if (!ambiente.armazenamento) {
      return false;
    }
    const ultimaRecarga = Number(ambiente.armazenamento.getItem(CHAVE_RECARGA));
    if (ultimaRecarga && ambiente.agora() - ultimaRecarga < INTERVALO_MINIMO_ENTRE_RECARGAS_MS) {
      return false;
    }
    ambiente.armazenamento.setItem(CHAVE_RECARGA, String(ambiente.agora()));
    return true;
  } catch (erro) {
    return false;
  }
};

// Apos um deploy o navegador pode estar com o index.html antigo, que aponta para chunks que nao existem mais;
// recarregar a pagina busca o index.html novo
export const carregaChunk = async <T>(importa: () => Promise<T>, ambiente: AmbienteChunk = AMBIENTE_NAVEGADOR): Promise<T> => {
  try {
    return await importa();
  } catch (erro) {
    if (!erroDeChunk(erro)) {
      throw erro;
    }
  }
  await ambiente.espera(ESPERA_ANTES_DE_TENTAR_DE_NOVO_MS);
  try {
    return await importa();
  } catch (erro) {
    if (!erroDeChunk(erro) || !registraRecarga(ambiente)) {
      throw erro;
    }
    ambiente.recarrega();
    return new Promise<T>(() => undefined);
  }
};
